  
    import { Emit, Component, Mixins, Ref, Prop, InjectReactive, Provide, ProvideReactive } from "vue-property-decorator";
    import ETable from "@/components/ETable.vue";
  
    import Resize from "@/mixins/resize";
    import TablePagination from "@/mixins/tablePagination";

    import { ElForm } from "element-ui/types/form";

    import { formatTextarea } from "@/utils/common"

    import { anxietySyndromesList, editAnxietySyndromesList } from "@/api/consultation"

    import { cloneDeep } from "lodash";
  
    @Component({
      components: {
        ETable,
      }
    })
    export default class EightList extends Mixins(TablePagination, Resize) {
      @Ref("formRef") formRef !: ElForm;
      
      tableData: Array<any> = [
      ];
      tableLoading = false;
      columns = [
        { label: "名称", prop: "name" },
        { label: "互斥", prop: "mutualExclusion" },
        { label: "舌象", prop: "", formatter: (row) => `${row.tongueColor}/${row.tongueMainifestation}` },
        { label: "成因", prop: "cause" },
        { label: "常见表现", prop: "commonPerformance" },
        { label: "操作人", prop: "modifiedBy" },
        { label: "最后操作时间", prop: "modifiedTime" },
        { label: "操作", width: 100, prop: "action"},
    ]
  
    dialogForm = {
      id: "",
      name: "",
      mutualExclusion: "",
      tongueColor: "",
      tongueMainifestation: "",
      cause: "",
      commonPerformance: "",
    };

    dialogFormRules = {
      name: { required: false, message: "", trigger: "" },
      mutualExclusion: { required: false, message: "", trigger: "" },
      tongueMainifestation: { required: false, message: "", trigger: "" },
      cause: { required: true, message: "请输入成因", trigger: "blur" },
    };
      dialogVisible = false;
  
      mounted() {
        this.windowResize(310);
        // 这里可以添加获取初始数据的逻辑，如果没有查询和分页，可以直接赋值
        this.getData();
      }
      formatTextarea(content) {
        return formatTextarea(content)
      }

      getData() {
        anxietySyndromesList().then((res) => {
          this.tableData = res.data;
        })
      }

      edit(row) {
        this.dialogVisible = true;
        Object.assign(this.dialogForm, cloneDeep(row));
      }

      save() {
        this.formRef?.validate().then(() => {
          editAnxietySyndromesList({ ...this.dialogForm }).then(() => {
            this.cancel();
            this.getData();
            this.$message.success("操作成功");
          })
        })
      }

      cancel() {
        this.handleClose();
      }
  
      handleClose() {
        this.dialogForm.id = "";
        this.formRef?.resetFields();
        this.dialogVisible = false;
      }
  
    }
  